// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "root-wRq6U";
var _4 = "notification-1dGFB";
var _5 = "notification__context-3xpeL";
var _6 = "notification__icon-3Fs0D";
var _7 = "notification__text-3W8mJ";
var _8 = "notification__button-29gs_";
var _9 = "button-1PrMH";
export { _1 as "__esModule", _2 as "mobile", _3 as "root", _4 as "notification", _5 as "notification__context", _6 as "notification__icon", _7 as "notification__text", _8 as "notification__button", _9 as "button" }
export default { "__esModule": _1, "mobile": _2, "root": _3, "notification": _4, "notification__context": _5, "notification__icon": _6, "notification__text": _7, "notification__button": _8, "button": _9 }
